import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import SystemControl from '../assets/equipment/3.18-system-control-panel.png';
import InspectionMonitor from '../assets/equipment/3.19-inspection-monitor.png';
import HMI from '../assets/equipment/3.20-HMI-panel.png';

import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>System Control</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="System Control Console" className="mb-3">
								<Tab eventKey="System Control Console" title="System Control Console">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>SYSTEM CONTROL CONSOLE</h2>
											<p>The “control desk” hosts the interface to the server (keyboard/mouse inputs, screen display, etc.), as well as the connections to the scanning cell, and power to the cameras. The monitor displays all defect information captured with the scanners in the inspection cell. The vision system can identify and categorize each defect including its location, size, and type. This system collects data that can be analyzed for actionable insights so you can optimize your processes. The console HMI includes several hardwired pushbuttons including an E-stop for additional controls.</p>
											<p>The monitor, seen above the center of the control desk, displays the currently selected server’s desktop along with the PowerPaint HMI.</p>

											<p>There is a stack light mounted on top of the monitor when illuminated indicates a system status.</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={SystemControl} alt="Master Key Box" style={{ width: '34vw', margin: '20px' }} />
												<figcaption>Figure 1: System Control Console</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								{/* <Tab eventKey="Inspection Monitor" title="Inspection Monitor">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>INSPECTION MONITOR (MON)</h2>
											<p>The Overhead Display is fed information upon a complete scan and displays know defect locations for operator use and archiving.</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={InspectionMonitor} alt="Master Key Box" style={{ width: '28vw', margin: '20px' }} />
												<figcaption>Figure 1: AWAITING NEW FIGURE</figcaption>
											</figure>
										</div>
									</div>
								</Tab> */}

								{/* <Tab eventKey="HMI" title="HMI">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>HUMAN MACHINE INTERFACE (HMI)</h2>
											<p>The PowerPaint HMI is the interface through which the user can access data about the system, look up diagnostic information, check service logs, Start/Stop scanning process, and more. This control center also routes physical connections and power to the Inspection Cell.</p>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Name</th>
														<th>Style</th>
														<th>Function</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>SILENCE ALARMS</td>
														<td>Black Pushbutton</td>
														<td>Silences the alarm horn when pressed.</td>
													</tr>
													<tr>
														<td>FAULT RESET</td>
														<td>Black Pushbutton</td>
														<td>Resets active fault when pressed.</td>
													</tr>
													<tr>
														<td>CONVEYOR IN-CYCLE BYPASS</td>
														<td>2-Position Keyed Switch</td>
														<td>Allows the operator to place the conveyor to the cell in By-pass or In-cycle mode.</td>
													</tr>
													<tr>
														<td>EMERGENCY STOP</td>
														<td>Red Illuminated Pushbutton</td>
														<td>Press to immediately stop all machine motion. Servo power is disabled. Illuminates red to indicate in E-Stop condition.</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure>
												<img src={HMI} alt="Master Key Box" style={{ width: '40vw', margin: '20px' }} />
												<figcaption>Figure 1: HMI Panel</figcaption>
											</figure>
										</div>
									</div>
								</Tab> */}
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
